import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';

import ExcelUploadTr from '../../components/OzelTasimalar/ExcelUploadTr';
import TasimaListesi from '../../components/OzelTasimalar/TasimaListesi';
import api from '../../services/api-configuration';
import './OzelTasimalar.scss';
import { useAuth } from '../../auth';

const OzelTasimalar = () => {
    const [activeTab, setActiveTab] = useState('1');
    const [allTasimalar, setAllTasimalar] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [dateRange, setDateRange] = useState([moment().subtract(30, 'days').toDate(), new Date()]);

    const { hasRole } = useAuth(24);

    const requiredColumns = [
        "sase",
        "shipment_type",
        "shipment_date",
        "from_location",
        "to_location",
        "requester",
        "transport_company",
        "brand",
        "model",
        "client_price",
        "transport_price",
        "shipment_reason",
    ];

    useEffect(() => {
        fetchTasimalar();

        // Excel yüklemesinden sonra listeyi güncelleme için event listener ekle
        const handleRefresh = (event) => {
            setAllTasimalar(event.detail);
        };
        window.addEventListener('refreshSpecialTransports', handleRefresh);

        // Cleanup
        return () => {
            window.removeEventListener('refreshSpecialTransports', handleRefresh);
        };
    }, []);

    const fetchTasimalar = async () => {
        setIsLoading(true);
        try {
            const response = await api.post('/getAllSpecialTransports');

            if (response.status === 404 || (response.data.success === false && response.data.message === "No special transports found for the given date range")) {
                setAllTasimalar([]);
                toast.info("Özel taşıma kaydı bulunmamaktadır.");
            } else if (response.data.success === false) {
                setAllTasimalar([]);
                toast.error(response.data.message || "Veriler yüklenirken bir hata oluştu!");
            } else {
                const sortedData = response.data.data.sort((a, b) => b.id - a.id);
                setAllTasimalar(sortedData);
            }
        } catch (error) {
            setAllTasimalar([]);
            if (error.response?.status === 404) {
                toast.info("Özel taşıma kaydı bulunmamaktadır.");
            } else {
                toast.error("Veriler yüklenirken bir hata oluştu!");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleFilter = () => {
        setIsLoading(true);
        try {
            fetchTasimalar();
        } catch (error) {
            toast.error("Filtreleme sırasında bir hata oluştu!");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        setIsLoading(true);
        try {
            await api.post('/deleteSpecialTransportByID', { id: id });
            toast.success("Kayıtlar başarıyla silindi!");
            fetchTasimalar();
        } catch (error) {
            toast.error("Kayıtlar silinirken bir hata oluştu!");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="ozel-tasimalar-container">
            <Breadcrumb current="Özel Taşımalar" />
            <Card className="mt-1">
                <CardBody className='p-1'>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={activeTab === '1' ? 'active' : ''}
                                onClick={() => setActiveTab('1')}
                                style={{ cursor: 'pointer' }}
                            >
                                <i className="fa fa-list mr-2"></i>
                                Özel Taşıma Listesi
                            </NavLink>
                        </NavItem>
                        {
                            hasRole('ozel_tasimalar_write') &&
                            <NavItem>
                                <NavLink
                                    className={activeTab === '2' ? 'active' : ''}
                                    onClick={() => setActiveTab('2')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className="fa fa-file-excel-o mr-2"></i>
                                    Excel ile Yeni Kayıt
                                </NavLink>
                            </NavItem>}
                    </Nav>

                    <TabContent activeTab={activeTab} className="mt-3">
                        <TabPane tabId="1">
                            <TasimaListesi
                                allTasimalar={allTasimalar}
                                isLoading={isLoading}
                                dateRange={dateRange}
                                handleFilter={handleFilter}
                                handleDelete={handleDelete}
                            />
                        </TabPane>

                        <TabPane tabId="2">
                            <ExcelUploadTr
                                process_type="SPECIAL_TRANSPORT"
                                ExcelName="Özel Taşımalar"
                                Title="Özel Taşımalar"
                                showBreadcrumb={false}
                                role_name="ozel_tasimalar_write"
                            />
                        </TabPane>
                    </TabContent>
                </CardBody>
            </Card>
        </div>
    );
};

export default OzelTasimalar;